
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><MDXTag name="p" components={components}>{`MeToo, genderneutrale Sprache, Statuen von historischen Unholden oder «Cancel Culture»: In letzter Zeit häufen sich die Debatten um politisch korrektes Handeln. Sollte der Begriff «Mohrenkopf» gestrichen werden? Wann geht ein Kompliment an eine Bürokollegin zu weit? Während die einen in der Political Correctness den Schutz von Minderheiten sehen oder damit gegen Diskriminierung ankämpfen, sehen andere die Meinungsfreiheit bedroht und fürchten gar öffentlichen Gesinnungsterror. Inwiefern folgt dieser Graben dem politischen Links-Rechts-Spektrum? Und wie politisch korrekt sind Sie selbst eingestellt? Dieses Quiz zeigt es. `}<a href='#methodik'><i className='ui angle double down icon' />{`Mehr zur Methodik finden Sie hier.`}</a></MDXTag>
           </MDXTag>
  }
}
MDXContent.isMDXComponent = true
  